import {StudentPaymentMethod, StudentPaymentMethodType} from "types/student-account/student-payment"

// Sentinel value for "add a new payment method" in a saved-method selector, distinct from any real
// paymentMethodId (which are positive integers).
export const PAYMENT_METHOD_NEW = -1

export const formatSavedPaymentMethodLabel = (method: StudentPaymentMethod) => {
    if (method.type === StudentPaymentMethodType.UsBankAccount || method.type === StudentPaymentMethodType.Ach) {
        const bankName = method.bankName || "Bank account"
        const accountType = method.bankAccountType ? ` ${method.bankAccountType}` : ""
        const last4 = method.bankAccountNumber || method.last4 || "----"
        return `${bankName}${accountType} **** ${last4} (ACH)`
    }

    const brand = method.cardBrand?.toUpperCase() || "CARD"
    const last4 = method.last4 || "----"
    const expMonth = method.expMonth ?? "--"
    const expYear = method.expYear ?? "--"
    return `${brand} **** ${last4} (${expMonth}/${expYear})`
}
